import React, { Fragment, FunctionComponent } from "react";

import { Layout, SpacingSize } from "@multiweb/reactComponents";
import { FormSearchInput } from "../FormSearchInput";
import { MenuTitle } from "../MenuTitle";

export type QuickAccessMenuHeaderComponentProps = {
    /** Lokalizovaný nadpis pro menu Rychlý přístup */
    title: string | undefined;
};

/** Komponenta hlavičky menu Rychlý přístup. Obsahuje nadpis a pole pro vyhledávání. */
export const QuickAccessMenuHeaderComponent: FunctionComponent<QuickAccessMenuHeaderComponentProps> = ({ title }) => (
    <Fragment>
        <MenuTitle text={title} />
        <Layout
            spacingSizeVertical={SpacingSize.xs}
            spacingSizeHorizontal={SpacingSize.m}
        >
            <FormSearchInput />
        </Layout>
    </Fragment>
);
